import React from "react";
import {useTranslation} from "react-i18next";
import {Chart as ChartJS, ArcElement, Legend, Tooltip} from "chart.js";
import {Doughnut} from "react-chartjs-2";
import {PIE_OPTIONS} from "../../Dashboard/Events/Requested/Model/Models";
import {BUILDING_DOUGHNUT_CUTOUT, doughnutCenterTextPlugin} from "../Model/Model";

// The doughnut needs its own registration, the building detail does not load the graphs page
ChartJS.register(ArcElement, Tooltip, Legend);

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Verified and unverified residents of the building, the hole paints the
 * residents counted by the detail.
 *
 * @param {Array} summary - Resident verification summary of the resume cards.
 * @param {number} totalResidents - Residents of the building.
 */

const BuildingResidentsDoughnut = ({
    summary,
    totalResidents
}) => {
    const {t} = useTranslation();
    const total = totalResidents || 0;
    const counted = summary?.reduce((acc, item) => acc + (item?.total || 0), 0) || 0;

    const data = {
        labels: summary?.map((item) => t(item?.titleTrans)) || [],

        datasets: [
            {
                data: summary?.map((item) => item?.total || 0) || [],
                backgroundColor: summary?.map((item) => item?.color) || [],
                borderColor: summary?.map((item) => item?.borderColor) || []
            }
        ]
    };

    // The total travels in the options, they are the ones refreshed when the
    // residents of the building change, the plugin is only built once
    const options = {
        ...PIE_OPTIONS,
        cutout: BUILDING_DOUGHNUT_CUTOUT,
        plugins: {
            ...PIE_OPTIONS.plugins,
            doughnutCenterText: {total, label: t('users')}
        }
    };

    return (
       <>
           { counted > 0 &&
               <div className={"h-180px"}>
                   <Doughnut
                       data={data}
                       options={options}
                       plugins={[doughnutCenterTextPlugin({total, label: t('users')})]}
                   />
               </div>
           }
       </>
    );
};

export default BuildingResidentsDoughnut;
